const modelingSound = localStorage.getItem('modelingSound')
const modelingSelectedSound = localStorage.getItem('modelingSelectedSound')

export default {
  modelingServiceData: null,
  modelingSelectedService: null,
  modelingSelectedServiceDetails: null,
  modelingLogs: {},
  modelingSound,
  modelingNewWorkspaceCreated: null,
  modelingNeedSystemLimits: 0,
  modelingSystemLimits: {
    memory: {
      title: 'Оперативная память',
      icon: 'IconLimitMemory',
      units: 'Гб',
      total: 0,
      used: 0,
      remain: 0,
      percent: 0,
      threshold: 10,
    },
    disk: {
      title: 'Место на диске',
      icon: 'IconLimitDisk',
      units: 'Гб',
      total: 0,
      used: 0,
      remain: 0,
      percent: 0,
      threshold: 10,
    },
    cpu: {
      title: 'Процессор',
      icon: 'IconLimitCpu',
      units: '',
      total: 0,
      used: 0,
      remain: 0,
      percent: 0,
      threshold: 50,
    }
  },
  modelingSoundsMap: {
    bell1: require('../../assets/media/bell1.mp3'),
    bell2: require('../../assets/media/bell2.mp3'),
    bell3: require('../../assets/media/bell3.mp3'),
    bell4: require('../../assets/media/bell4.mp3'),
    bell5: require('../../assets/media/bell5.mp3'),
    bell6: require('../../assets/media/bell6.mp3'),
    bell7: require('../../assets/media/bell7.mp3'),
    bell8: require('../../assets/media/bell8.mp3'),
    bell9: require('../../assets/media/bell9.mp3'),
    bell10: require('../../assets/media/bell10.mp3'),
  },
  modelingSelectedSound,
}



// WEBPACK FOOTER //
// ./src/store/modeling/defaults.js